import { z } from 'zod';

/**
 * Tenant setting `BILLING_SAAS_METRICS_SETTINGS` (ALC-1419).
 *
 * `suspensionChurnThresholdDays` is the number of consecutive days a contract may
 * remain SUSPENDED before MRR movements (ALC-1428) classify the suspended value as
 * churn. Default 90. Committed/suspended buckets on the metrics endpoint still report
 * suspended contracts in the suspended-MRR bucket regardless of this threshold —
 * the threshold only drives movement classification.
 */
export const BillingSaasMetricsSettingsSchema = z.object({
  suspensionChurnThresholdDays: z.number().int().min(1).max(3650),
});

export type BillingSaasMetricsSettings = z.infer<typeof BillingSaasMetricsSettingsSchema>;

export const DEFAULT_SUSPENSION_CHURN_THRESHOLD_DAYS = 90;

export function getDefaultBillingSaasMetricsSettings(): BillingSaasMetricsSettings {
  return {
    suspensionChurnThresholdDays: DEFAULT_SUSPENSION_CHURN_THRESHOLD_DAYS,
  };
}
